import { Logger } from '~/plugins/log'
const logger = new Logger()
logger.setContext('Support')

const getDefaultState = () => ({
  articles: [],
  categories: [],
  mappings: {},
  lastUpdate: null,
  ownersManualResponses: {}
})

export const state = getDefaultState

export const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  SET (state, { data, page }) {
    // Add articles ensuring uniqueness
    state.articles = [
      ...state.articles,
      ...data.articles.filter(article => !state.articles.find(a2 => a2 === article.id))
    ]

    // Add categories ensuring uniqueness
    state.categories = [
      ...state.categories,
      ...data.categories.filter(category => !state.categories.find(c2 => c2 === category.id))
    ]

    state.mappings = {
      ...state.mappings,
      [page || 'support']: data.mapping
    }

    state.lastUpdate = (new Date()).valueOf()
  },
  SET_OWNERS_MANUAL (state, { data, product }) {
    state.ownersManualResponses = {
      ...state.ownersManualResponses,
      [product]: data
    }
  }
}

export const getters = {
  mapping: state => page => state.mappings[page || 'support'] || [],
  categories: (state, getters) => (page) => {
    return [...new Set(getters.mapping(page).map(mapping => mapping.category))].map(
      (categoryId) => {
        const category = state.categories.find(category => category.id === categoryId)
        if (!category) return {}
        return {
          ...category,
          articles: getters.articlesForCategory(page, category.id)
        }
      }
    ).filter(category => Object.keys(category).length).sort((a, b) => a.ordering - b.ordering)
  },
  articlesForCategory: (state, getters) => (page, categoryId) => {
    return getters.mapping(page).filter(
      mapping => mapping.category === categoryId
    ).map(
      mapping => state.articles.find(article => article.id === mapping.article)
    ).sort(
      (a, b) => a.ordering - b.ordering
    ).filter(article => article)
  },
  articles: (state, getters) => (page) => {
    return getters.mapping(page).map(
      mapping => state.articles.find(article => article.id === mapping.article)
    ).filter(article => article)
  },
  ownersManualArticles: state => product => (state.ownersManualResponses[product] || {}).articles || []
}

export const actions = {
  async GET ({ commit, state }, page) {
    try {
      const { data } = await this.$publicAPI.get('support/', { params: { page }, useCache: true })
      commit('SET', { data, page })
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async TRACK_VIEW ({ state }, article) {
    try {
      await this.$publicAPI.quietPost(`support/${article}/view/`)
    } catch (error) {
      logger.error(error)
      this.app.$sentry.captureException(error)
    }
  },
  async RATE ({ rootGetters }, { article, rating }) {
    try {
      await this.$publicAPI.quietPost(`support/${article}/rate/`, { rating, sg18pid: rootGetters['store/sg18pid'] })
    } catch (error) {
      logger.error(error)
      this.app.$sentry.captureException(error)
    }
  },
  async TRACK_SEARCH ({ rootGetters }, { query, results }) {
    try {
      await this.$publicAPI.quietPost('support/track_search/', { query, results, sg18pid: rootGetters['store/sg18pid'] })
    } catch (error) {
      logger.error(error)
      this.app.$sentry.captureException(error)
    }
  },
  async GET_OWNERS_MANUAL_ARTICLES ({ commit }, product) {
    try {
      const { data } = await this.$publicAPI.get('support/owners_articles/', { params: { product }, useCache: true })
      commit('SET_OWNERS_MANUAL', { data, product })
      return data
    } catch (error) {
      logger.error(error)
      this.app.$sentry.captureException(error)
    }
  }
}
